import React from 'react';
import { AboutUsVideoWrapper } from './styled';

const AboutUsVideo = () => (
  <AboutUsVideoWrapper textAlign="center">
    <iframe
      width="560"
      height="315"
      src="https://www.youtube-nocookie.com/embed/8g3INgde97U"
      frameBorder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  </AboutUsVideoWrapper>
);

export default AboutUsVideo;
